import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getCategoryColor } from './category-color';

import type { ProductDirectoryCategory } from './product-directory-api';

type CategoryLegendProps = {
  categories: ProductDirectoryCategory[];
  /** A key with room beside the thing it explains reads as a row; one in a menu reads as a list. */
  direction?: 'row' | 'column';
};

function CategoryLegend({ categories, direction = 'row' }: CategoryLegendProps) {
  let gap = 2;
  if (direction === 'column') {
    gap = 1;
  }
  return (
    <Box
      component="ul"
      sx={{ display: 'flex', flexDirection: direction, flexWrap: 'wrap', gap: gap, listStyle: 'none', m: 0, p: 0 }}
    >
      {categories.map((category) => (
        <Box component="li" key={category.key} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Box
            data-category-swatch
            aria-hidden="true"
            sx={{
              width: 10,
              height: 10,
              borderRadius: '2px',
              bgcolor: getCategoryColor(category.key),
              flexShrink: 0,
            }}
          />
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {category.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export { CategoryLegend };
export type { CategoryLegendProps };
